<div class="numero_piezas">{{ numeroPiezas }}</div>
<div class="descripcion en-tránsito">EN TRÁNSITO</div>
